import { IDisposable } from "../../../Global/Base/IDisposable";
import { BreadcrumbNavItem } from "./BreadcrumbNavItem";
import { IWindowable } from "./UIManagerInterfaces";

/**
 * Interface obstarávající obsluhu drobečkové navigace
 * @includeToDoc
 */
export interface IBreadcrumbNav extends IDisposable {
    /**
     * Přidá položku do drobečkové navigace
     * @param form Odkaz na formulář
     */
    addNavigationItem(form: IWindowable): BreadcrumbNavItem;
    /**
     * Odstraní nejvyšší položku z drobečkové navigace
     */
    removeTopItem(): void;
    /** Nainicializuje drobečkovou navigaci */
    initialize(): Promise<void>;

    /** Skryje drobečkovou navigaci */
    hide(): void;
    /** Zobrazí drobečkovou navigaci */
    show(): void;
    /** Vrátí html element obsahující breadcrumbs */
    readonly element: HTMLElement;

    /**
     * Položky v navigaci
     */
    items: BreadcrumbNavItem[];
}

export class IBreadcrumbNav {
    private static _methods: (keyof(IBreadcrumbNav))[] = ["addNavigationItem", "removeTopItem", "initialize", "hide", "show"];
    private static _properties: (keyof(IBreadcrumbNav))[] = ["element"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null
        && !this._properties.some((value) => !Reflect.has(instance, value))
        && !this._methods.some(value => typeof instance[value] !== "function");
    }
}

export enum BreadcrumbNavItemIconType {
    arrow = "ui-chevron-right",
    close = "ui-circle-cross",
    view = "ui-eye",
}
